skrilla.directive('userChargeBacks', function () {
    return {
        templateUrl: 'directives/userChargebacks/userChargebacks.html',
        scope: {
            user: "="
        },
        controller: function ($scope, modalService, cacheService, searchService, currencyService, srefService, adminService) {
            $scope.hasRole = adminService.hasRole
            function get() {
                searchService.get(`users/${$scope.user.id}/chargeBacks`).then((response) => {
                    $scope.reports = response.data;
                });
            }

            $scope.createChargeBack = function(){
                cacheService.registerObject("user", $scope.user)
                modalService.openModal("views/chargebacks/createChargeback.html", true, 'lg', true, true, function(){
                    get();
                });
            }
            get();
        }
    };
});
